module.exports = __webpack_public_path__ + "static/effective-python-c65a81d86467943602b0783b1f26bc9c.jpeg";